
export default {
	'theory-cost-order': {
		id: 'theory-cost-order',
		label: '理论耗用单',
		code: '0006_0004',
		child: {
			'edit-bill': {
				id: 'edit-bill',
				label: '编辑理论耗用单',
				code: '0006_0004_002_001'
			},
			'del-bill': {
				id: 'del-bill',
				label: '删除理论耗用单',
				code: '0006_0004_004_001'
			},
			'submit-bill': {
				id: 'submit-bill',
				label: '提交理论耗用单',
				code: '0006_0004_009_001'
			},
			'return-bill': {
				id: 'return-bill',
				label: '退回理论耗用单',
				code: '0006_0004_010_001'
			},
			'check-bill': {
				id: 'check-bill',
				label: '审核理论耗用单',
				code: '0006_0004_011_001'
			},
			'uncheck-bill': {
				id: 'uncheck-bill',
				label: '反审理论耗用单',
				code: '0006_0004_012_001'
			},
			'recheck-bill': {
				id: 'recheck-bill',
				label: '复审理论耗用单',
				code: '0006_0004_013_001'
			},
			'unrecheck-bill': {
				id: 'unrecheck-bill',
				label: '取消复审理论耗用单',
				code: '0006_0004_014_001'
			},
			'print-bill': {
				id: 'print-bill',
				label: '打印理论耗用单',
				code: '0006_0004_015_001'
			},
			'export-bill': {
				id: 'export-bill',
				label: '导出理论耗用单明细数据',
				code: '0006_0004_040_003'
			}
		}
	}
}
